var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#31AD31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.968 18.52C12.992 17.6347 13.7973 16.9093 14.384 16.344C14.9813 15.768 15.4773 15.1707 15.872 14.552C16.2667 13.9333 16.464 13.3147 16.464 12.696C16.464 12.056 16.3093 11.5547 16 11.192C15.7013 10.8293 15.2267 10.648 14.576 10.648C13.9467 10.648 13.456 10.8507 13.104 11.256C12.7627 11.6507 12.5813 12.184 12.56 12.856H10.8C10.832 11.64 11.1947 10.712 11.888 10.072C12.592 9.42133 13.4827 9.096 14.56 9.096C15.7227 9.096 16.6293 9.416 17.28 10.056C17.9413 10.696 18.272 11.5493 18.272 12.616C18.272 13.384 18.0747 14.1253 17.68 14.84C17.296 15.544 16.832 16.1787 16.288 16.744C15.7547 17.2987 15.072 17.944 14.24 18.68L13.52 19.32H18.592V20.84H10.816V19.512L11.968 18.52Z",
    fill: "#31AD31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/Number2.a151d6dcb20111b64a07d415afa62289.svg";
export { ForwardRef as ReactComponent };